import styled from 'styled-components';
import { MainButton } from '../common/styles';

export const Container = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: center;
height: 100vh;
position: relative;
`;

export const WelcomeContainer = styled.div`
  max-width: 40%;
  position: absolute;
  top: 25%;
  color: ${(props) => {
    return props.theme.colors.textPrimary
  }};
  padding: 10px;
  border-radius: 5px;
  background: linear-gradient(${(props) => (props.isRTL ? 'to left' : 'to right')}, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.025));
  inset-inline-start: 0; /* This will be 'left: 0;' in LTR and 'right: 0;' in RTL */
`;

export const WelcomeText = styled.h1`
  margin-inline-start: 50px;
  font-size: 48px;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 20%;
  width: 100%;
  overflow: auto;
  padding: 20px;
  background: ${(props) => props.theme.colors.containerBackground};
  display: flex;
  justify-content: ${(props) => (props.center ? 'center' : undefined)};
  & > *:not(:last-child) {
    margin-inline-end: 25px;
  }
`;

export const Button = styled(MainButton)``;